import { LinkDetails } from '../../../../types/types';
import { getLinkData, SPXAPI } from '../../../../api';
import { handleNotFound } from '../../../../components/utils';

const fetchExistingLink = (API: SPXAPI, linkId: string): Promise<LinkDetails> => (
    handleNotFound<LinkDetails>(() => getLinkData(API, linkId))
);

export default fetchExistingLink;
